/**
 * Bilingual copy for the Solutions overview page.
 * `en` holds the exact original English strings; `km` mirrors them in Khmer.
 */
export const en = {
  kicker: 'Solutions',
  title: 'One system, every department',
  lead:
    'People, selling, buying, stock, the books, the till, and your web shop all work ' +
    'together — with the same customers, products, and approvals. Pick a journey below, ' +
    'or explore a module.',
  journeysLabel: 'End-to-end journeys',
  modulesLabel: 'Modules in the suite',
  journeyLinkLabel: 'How the journey works',
  journeySolutions: [
    {
      title: 'Sales',
      description:
        'CRM quotations, sales orders, invoices, POS, and the online store share one item catalog and one customer record — then receipts and AR land in Revenues.',
    },
    {
      title: 'Inventory',
      description:
        'Purchase orders, goods received, transfers, adjustments, and self-service withdrawals keep on-hand balances in sync with invoicing.',
    },
  ],
  ctaTitle: 'See it in action',
  ctaDescription:
    'Book a short walkthrough with our team and we will show you the parts of AKAS that fit your business.',
  ctaPrimaryLabel: 'Request a walkthrough',
  ctaSecondaryLabel: 'Browse the guides',
};

export type Copy = typeof en;

export const km: Copy = {
  kicker: 'ដំណោះស្រាយ',
  title: 'ប្រព័ន្ធតែមួយ សម្រាប់គ្រប់ផ្នែក',
  lead:
    'គ្រប់គ្រងបុគ្គលិក ការលក់ ការទិញ ស្តុក គណនេយ្យ របាយការណ៍ និងហាងអនឡាញរបស់អ្នកក្នុងប្រព័ន្ធតែមួយ ដែលតភ្ជាប់ទិន្នន័យអតិថិជន ទំនិញ និងលំហូរការងារអនុម័តយ៉ាងរលូន។ កាត់បន្ថយការងារស្ទួន បង្កើនប្រសិទ្ធភាព និងធ្វើឱ្យការគ្រប់គ្រងអាជីវកម្មកាន់តែងាយស្រួល។ ស្វែងយល់ពីលំហូរការងារ ឬម៉ូឌុលនីមួយៗខាងក្រោម ដើម្បីស្វែងរកដំណោះស្រាយដែលសមស្របនឹងអាជីវកម្មរបស់អ្នក។',
  journeysLabel: 'ដំណើរពីដើមដល់ចុង',
  modulesLabel: 'ម៉ូឌុលក្នុងដំណោះស្រាយ',
  journeyLinkLabel: 'របៀបដំណើរការ',
  journeySolutions: [
    {
      title: 'ការលក់',
      description:
        'សម្រង់តម្លៃក្នុងការគ្រប់គ្រងទំនាក់ទំនងអតិថិជន បញ្ជាលក់ វិក្កយបត្រ ការលក់តាមបញ្ជរ និងហាងអនឡាញ ប្រើបញ្ជីទំនិញ និងអតិថិជនរួមតែមួយ។ រាល់ការលក់ និងការទូទាត់ត្រូវបានភ្ជាប់ទៅការគ្រប់គ្រងចំណូល និងគណនីត្រូវទទួល (AR) ដើម្បីងាយស្រួលតាមដាន និងគ្រប់គ្រងហិរញ្ញវត្ថុ។',
    },
    {
      title: 'ស្តុក',
      description:
        'ការបញ្ជាទិញទំនិញ ការទទួលទំនិញ ការផ្ទេរស្តុក ការកែតម្រូវស្តុក និងការដកស្តុកដោយខ្លួនឯងរបស់បុគ្គលិក ជួយធានាថាបរិមាណស្តុកជាក់ស្តែងត្រូវបានធ្វើបច្ចុប្បន្នភាព និងស៊ីសង្វាក់គ្នាជាមួយការចេញវិក្កយបត្រ។',
    },
  ],
  ctaTitle: 'មើលវាក្នុងការប្រើប្រាស់ពិត',
  ctaDescription:
    'សុំការបង្ហាញសង្ខេបជាមួយក្រុមយើងខ្ញុំ ហើយយើងនឹងបង្ហាញអ្នកពីផ្នែកនៃ AKAS ដែលសាកសមនឹងអាជីវកម្មរបស់អ្នក។',
  ctaPrimaryLabel: 'សុំការបង្ហាញសង្ខេប',
  ctaSecondaryLabel: 'មើលមគ្គុទ្ទេសក៍ទាំងអស់',
};
